(function () {
  function init() {
    var root = document.querySelector('[data-abt-setlist]');
    if (!root) return;

    var list = root.querySelector('[data-list]');
    var playAll = root.querySelector('[data-play-all]');
    var addAll = root.querySelector('[data-add-all]');
    var addAllLabel = root.querySelector('[data-add-all-label]');
    var addAllText = addAllLabel.textContent;
    var resetBtn = root.querySelector('[data-reset]');
    var toastEl = root.querySelector('[data-toast]');
    var audio = new Audio();
    var current = null;
    var inCart = {};
    var toastTimer;

    var rows = function () { return Array.prototype.slice.call(list.querySelectorAll('[data-track]')); };
    var originalOrder = rows();

    function toast(message, withCartLink) {
      toastEl.innerHTML = '';
      toastEl.appendChild(document.createTextNode(message));
      if (withCartLink) {
        var link = document.createElement('a');
        link.href = root.dataset.cartUrl;
        link.textContent = 'View cart';
        toastEl.appendChild(link);
      }
      toastEl.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
    }

    /* Order */
    function renumber() {
      rows().forEach(function (row, i) { row.querySelector('[data-num]').textContent = i + 1; });
      var changed = rows().some(function (row, i) { return row !== originalOrder[i]; });
      resetBtn.hidden = !changed;
    }

    resetBtn.addEventListener('click', function () {
      originalOrder.forEach(function (row) { list.appendChild(row); });
      renumber();
    });

    list.addEventListener('keydown', function (e) {
      var handle = e.target.closest('[data-handle]');
      if (!handle || (e.key !== 'ArrowUp' && e.key !== 'ArrowDown')) return;
      e.preventDefault();
      var row = handle.closest('[data-track]');
      var sibling = e.key === 'ArrowUp' ? row.previousElementSibling : row.nextElementSibling;
      if (!sibling) return;
      list.insertBefore(row, e.key === 'ArrowUp' ? sibling : sibling.nextElementSibling);
      handle.focus();
      renumber();
      toast(row.dataset.title + ' moved to position ' + (rows().indexOf(row) + 1));
    });

    if (window.Sortable) {
      Sortable.create(list, {
        handle: '[data-handle]',
        animation: 200,
        easing: 'cubic-bezier(.2, .8, .2, 1)',
        forceFallback: true,
        ghostClass: 'is-ghost',
        chosenClass: 'is-chosen',
        fallbackClass: 'is-drag',
        onStart: function () { root.classList.add('is-sorting'); },
        onEnd: function () { root.classList.remove('is-sorting'); renumber(); }
      });
    }

    /* Previews */
    function setActive(row) {
      if (current && current !== row) {
        current.classList.remove('is-active', 'is-playing');
        current.style.removeProperty('--p');
      }
      current = row;
      if (row) row.classList.add('is-active');
    }

    function playRow(row) {
      if (!row) return;
      if (row === current) {
        audio.paused ? audio.play() : audio.pause();
        return;
      }
      setActive(row);
      audio.src = row.dataset.preview;
      audio.play().catch(function () {});
    }

    function nextPlayable(row) {
      var all = rows();
      for (var i = all.indexOf(row) + 1; i < all.length; i++) {
        if (all[i].dataset.preview) return all[i];
      }
      return null;
    }

    audio.addEventListener('play', function () {
      if (current) current.classList.add('is-playing');
      playAll.classList.add('is-playing');
      playAll.setAttribute('aria-label', 'Pause previews');
    });
    audio.addEventListener('pause', function () {
      if (current) current.classList.remove('is-playing');
      playAll.classList.remove('is-playing');
      playAll.setAttribute('aria-label', 'Play all previews');
    });
    audio.addEventListener('timeupdate', function () {
      if (current && audio.duration) current.style.setProperty('--p', audio.currentTime / audio.duration);
    });
    audio.addEventListener('ended', function () {
      var next = nextPlayable(current);
      if (next) playRow(next);
      else setActive(null);
    });

    playAll.addEventListener('click', function () {
      if (current) { playRow(current); return; }
      var first = rows().filter(function (row) { return row.dataset.preview; })[0];
      playRow(first);
    });

    /* Cart */
    function syncCart(cart) {
      inCart = {};
      cart.items.forEach(function (item) { inCart[item.variant_id] = true; });
      var all = rows();
      all.forEach(function (row) {
        var added = !!inCart[row.dataset.variantId];
        row.classList.toggle('is-in-cart', added);
        row.querySelector('[data-add]').setAttribute('aria-label', (added ? 'In your cart: ' : 'Add to cart: ') + row.dataset.title);
      });
      var allIn = all.every(function (row) { return inCart[row.dataset.variantId]; });
      addAllLabel.textContent = allIn ? 'Whole setlist in your cart' : addAllText;
    }

    function fetchCart() {
      return fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { syncCart(cart); return cart; });
    }

    function addRows(targetRows, button) {
      var pending = targetRows.filter(function (row) { return !inCart[row.dataset.variantId]; });
      if (!pending.length) {
        toast(targetRows.length > 1 ? 'The whole setlist is already in your cart' : 'Already in your cart', true);
        return;
      }
      button.setAttribute('aria-busy', 'true');
      fetch(root.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: pending.map(function (row) { return { id: Number(row.dataset.variantId), quantity: 1 }; }) })
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return fetchCart(); })
        .then(function (cart) {
          if (window.halo && typeof halo.updateSidebarCart === 'function') {
            halo.updateSidebarCart(cart);
          } else {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          }
          toast(pending.length === 1 ? pending[0].dataset.title + ' added to your cart' : pending.length + ' tracks added to your cart', true);
        })
        .catch(function () { toast('Sorry, that didn’t work. Please try again.'); })
        .finally(function () { button.removeAttribute('aria-busy'); });
    }

    list.addEventListener('click', function (e) {
      var play = e.target.closest('[data-play]');
      if (play) { playRow(play.closest('[data-track]')); return; }
      var add = e.target.closest('[data-add]');
      if (add) addRows([add.closest('[data-track]')], add);
    });

    addAll.addEventListener('click', function () { addRows(rows(), addAll); });

    var useBtn = root.querySelector('[data-use]');
    if (useBtn) useBtn.addEventListener('click', function () {
      toast('Coming soon: save this set to your own setlists, ready to rename and reorder.');
    });

    fetchCart().catch(function () {});
    document.addEventListener('cart-update', function (e) {
      if (e.detail && e.detail.items) syncCart(e.detail);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Setlists page: instrument and vocal filters */
(function () {
  function init() {
    var root = document.querySelector('[data-abt-setlists]');
    if (!root) return;
    var state = { inst: 'all', voice: 'all' };
    var empty = root.querySelector('[data-empty]');

    function matches(card) {
      return ['inst', 'voice'].every(function (key) {
        var value = card.dataset[key];
        return state[key] === 'all' || value === 'any' || value === state[key];
      });
    }

    function apply() {
      var shown = 0;
      root.querySelectorAll('[data-group]').forEach(function (group) {
        var visible = 0;
        group.querySelectorAll('[data-card]').forEach(function (card) {
          var ok = matches(card);
          card.hidden = !ok;
          if (ok) visible++;
        });
        group.hidden = !visible;
        shown += visible;
      });
      empty.hidden = shown > 0;
    }

    root.querySelectorAll('[data-filter]').forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-value]');
        if (!chip) return;
        state[bar.dataset.filter] = chip.dataset.value;
        bar.querySelectorAll('[data-value]').forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        apply();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
